<template>
  <div
    class="landing-section-wrapper"
    :style="{'background-color': backgroundColor}"
  >
    <div class="landing-section-wrapper__container container">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LandingSectionWrapper',
  props: {
    backgroundColor: {
      type: String,
      required: true,
    },
  },
};
</script>

<style
  scoped
  lang="scss"
>
@import "~@/assets/scss/mixins";

.landing-section-wrapper {
  &__container {
    padding: 32px 24px;

    @include media-lg() {
      padding: 128px 5px;
    }
  }
}
</style>
